import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { handleAdminLoggedOutLandingPage } from './app/core/utils/cross-app-logout.util';
import { redirectToAdminAuthIfUnauthenticated } from './app/core/utils/admin-auth-entry.util';
import { environment } from './environments/environment';


if (handleAdminLoggedOutLandingPage()) {
  // Logout relay redirect in progress — skip bootstrapping this load.
} else if (redirectToAdminAuthIfUnauthenticated(environment)) {
  // Unauthenticated visit — redirect to dev-auth/?app=admin before SPA boot.
} else {

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
}
